<div class="sigma_cart-sidebar-body">
    <!-- Data -->
    <div class="sigma_cart-sidebar-item" *ngFor="let item of cartItems">
        <div class="sigma_cart-sidebar-item-body">
            <!-- <a routerLink="/shop-details/{{item.id}}"><img [src]="item.image[0]" [alt]="item.title"></a> -->
            <div class="sigma_cart-sidebar-item-body-inner">
                <h5> <a routerLink="/shop-details/{{item.id}}">{{item.title}}</a> </h5>
                <span>{{getItemQuantity(item)}}x {{item.price * (100 - item.discount) / 100 | number:'1.2-2'}}$</span>
            </div>
        </div>
        <div class="sigma_cart-sidebar-price">
            {{item.price * (100 - item.discount) / 100 * getItemQuantity(item) | number:'1.2-2'}}$
        </div>
        <div class="close-btn close-dark" (click)="handleDeleteFromCart(item)">
            <span></span>
            <span></span>
        </div>
    </div>
    <!-- Data -->
</div>
<div class="sigma_cart-sidebar-footer">
    <h4>Total: <span>{{calculateprice() | number:'1.2-2'}}$</span> </h4>
    <a routerLink="/checkout" class="sigma_btn-custom">Checkout</a>
</div>